import React, { useState, useEffect } from 'react';
import { Phone, X } from 'lucide-react';
import { businessInfo } from '../mockData';

const FloatingCallButton = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isMinimized, setIsMinimized] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 100px
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  if (isMinimized) {
    return (
      <button
        onClick={() => setIsMinimized(false)}
        className="fixed bottom-6 right-6 z-50 bg-gradient-to-r from-sky-600 to-cyan-600 hover:from-sky-700 hover:to-cyan-700 text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transition-all hover:scale-110 animate-pulse"
        aria-label="Call us"
      >
        <Phone size={24} />
      </button>
    );
  }

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-in slide-in-from-bottom">
      <div className="relative bg-gradient-to-r from-sky-600 to-cyan-600 text-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Close button */}
        <button
          onClick={() => setIsMinimized(true)}
          className="absolute top-2 right-2 p-1 hover:bg-white/20 rounded-full transition-colors"
          aria-label="Minimize"
        >
          <X size={18} />
        </button>

        {/* Content */}
        <div className="p-6 pr-10">
          <div className="flex items-center gap-3 mb-2">
            <div className="bg-white/20 p-2 rounded-full">
              <Phone size={20} />
            </div>
            <div>
              <div className="text-sm font-medium opacity-90">Ring oss nå!</div>
              <div className="text-xs opacity-75">Gratis konsultasjon</div>
            </div>
          </div>
          
          <a
            href={`tel:${businessInfo.phone}`}
            className="block bg-white text-sky-600 text-center font-bold text-lg py-3 px-6 rounded-xl hover:bg-gray-100 transition-all hover:scale-105 shadow-lg"
          >
            {businessInfo.phone}
          </a>
          
          <div className="text-xs text-center mt-2 opacity-75">
            Man-Fre: {businessInfo.openingHours.weekdays}
          </div>
        </div>

        {/* Animated pulse ring */}
        <div className="absolute -inset-1 bg-gradient-to-r from-sky-600 to-cyan-600 rounded-2xl opacity-20 animate-ping"></div>
      </div>
    </div>
  );
};

export default FloatingCallButton;
